import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {DcService } from '../../../services/dc.service'
import {DcMaintainenceResponse} from '../../model/dc-maintainence-response';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { SortableColumn } from '../../model/sort/sortable-column';


@Component({
    selector: 'app-dc-maintainence',
    templateUrl: './dc-maintainence.component.html',
    styleUrls: ['./dc-maintainence.component.scss'],
    standalone: false
})
export class DcMaintainenceComponent implements OnInit,AfterViewInit {

  displayedColumns: string[] = ['dcNumber', 'address', 'city', 'province','details'];
  dataSource :MatTableDataSource<DcMaintainenceResponse>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  sortableColumn:SortableColumn;

  user: UsersDataResponse;
  userData: UserData;
  constructor(private dcservice:DcService,private userservice:UserService,private router:Router){
  
    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      
    })
  }
  ngOnInit(): void {

    this.dcservice.getAllDC(this.userData.upn).subscribe(data=>{
      this.dataSource=new MatTableDataSource<DcMaintainenceResponse>(data);
     // this.sort=new MatSort();
      //this.dataSource.sort=this.sort;
    });
    
    
  }

  ngAfterViewInit() {
  //  this.sort=new MatSort();
  //  this.dataSource.paginator = this.paginator;
    //this.dataSource.sort=this.sort;
   
  //  this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
   
    
  }
  viewDcDetails(dc:DcMaintainenceResponse){
    this.router.navigate(['/dcn-esign/administration/edit-dc',dc.dcNumber],{ queryParams: { 'action': 'dc-edit'}});
  }

  sortData(sort: Sort) {
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

}
